//点击导航
function productHeaderInit() {
    let regNumber = /\d+/;
    var index = location.href.lastIndexOf("/");
    let obj = location.href.substring(index+1,location.href.length);
    if(location.href.indexOf('product')>=0 && regNumber.test(obj)){
      $(".header-wrap").addClass("no-show");
      $(".footer-wrap").addClass("no-show");
    }

    if(location.href.indexOf('area')>=0 && regNumber.test(obj)){
      $(".header-wrap").addClass("no-show");
      // $(".footer-wrap").addClass("no-show");
    }
    if(location.href.indexOf('supply')>=0){
      $(".release").addClass("no-show");
      // $(".footer-wrap").addClass("no-show");
    }
}

const init = () => {
    productHeaderInit();
};
module.exports = { init };